/**
 * Helper functions for CustomerDetail page
 */

import { CustomerProfile } from '../../lib/api';

export function getRatingColor(rating: string | number): string {
  const numRating = typeof rating === 'string' ? parseFloat(rating) : rating;
  if (numRating >= 4.5) return 'text-green-600 dark:text-green-400';
  if (numRating >= 4.0) return 'text-blue-600 dark:text-blue-400';
  if (numRating >= 3.5) return 'text-yellow-600 dark:text-yellow-400';
  return 'text-red-600 dark:text-red-400';
}

export function getStatusBadgeColor(status: string): string {
  const statusColors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
    sent: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    acknowledged: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
    in_progress: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
    delivered: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    closed: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800';
}

export function getSeverityColor(severity: string): string {
  const colors: Record<string, string> = {
    critical: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    major: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
    minor: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  };
  return colors[severity] || 'bg-gray-100 text-gray-800';
}

export function getFullAddress(customer: CustomerProfile): string | null {
  const parts = [
    customer.company_details.address_line_1,
    customer.company_details.address_line_2,
    customer.company_details.city,
    customer.company_details.state,
    customer.company_details.postal_code,
    customer.company_details.country,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : null;
}

export function getCapabilitiesList(customer: CustomerProfile): string[] {
  if (!customer.capabilities) return [];

  // Handle both array and object formats
  if (Array.isArray(customer.capabilities)) {
    return customer.capabilities;
  }

  // If it's an object, extract relevant fields
  const caps = customer.capabilities as Record<string, unknown>;
  const list: string[] = [];

  if (caps['commodity_group']) list.push(`${caps['commodity_group']}`);
  if (caps['commodity_type']) list.push(`${caps['commodity_type']}`);
  if (caps['commodity_manager']) list.push(`Manager: ${caps['commodity_manager']}`);
  if (caps['is_strategic']) list.push('Strategic Supplier');

  return list;
}
